export default __webpack_public_path__ + "static/media/Logo_evision.8294a415.png";